import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
  Alert,
  Paper,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export const CTOTModal = ({ isOpen, onClose, ctotData }) => {
  const { ctot, taxiTime, ctotMsg, errorMsg } = ctotData || {};

  const formatCtotMessage = (message) => {
    if (!message) return [];
    return message.split("\n").filter((line) => line.trim() !== "");
  };

  const ctotLines = formatCtotMessage(ctotMsg);

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          minWidth: { xs: "90%", sm: 400 },
          maxWidth: 600,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >
        <Typography variant="h5" component="span" fontWeight="bold">
          CTOT Information
        </Typography>
        <IconButton
          edge="end"
          color="inherit"
          onClick={onClose}
          aria-label="close"
          size="small"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        {errorMsg && errorMsg.trim() !== "" && (
          <Alert severity="error" sx={{ mb: 2 }}>
            <Typography variant="body2">{errorMsg}</Typography>
          </Alert>
        )}

        {ctot && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              py: 1.5,
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <Typography fontWeight="bold" color="text.secondary">
              CTOT:
            </Typography>
            <Typography fontWeight="bold" color="error.main">
              {ctot}
            </Typography>
          </Box>
        )}

        {taxiTime && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              py: 1.5,
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <Typography fontWeight="bold" color="text.secondary">
              Taxi Time:
            </Typography>
            <Typography fontWeight="bold" color="error.main">
              {taxiTime}
            </Typography>
          </Box>
        )}

        {ctotLines.length > 0 && (
          <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
              Slot Information:
            </Typography>
            <Paper
              variant="outlined"
              sx={{
                p: 2,
                bgcolor: "grey.50",
                fontFamily: "monospace",
                fontSize: "0.813rem",
                lineHeight: 1.6,
              }}
            >
              {ctotLines.map((line, index) => (
                <Typography
                  key={index}
                  variant="body2"
                  component="div"
                  sx={{
                    fontFamily: "monospace",
                    fontSize: "0.813rem",
                    my: 0.5,
                    color: "text.primary",
                  }}
                >
                  {line}
                </Typography>
              ))}
            </Paper>
          </Box>
        )}

        {!ctot && !taxiTime && !ctotMsg && !errorMsg && (
          <Box sx={{ textAlign: "center", py: 4 }}>
            <Typography variant="body1" color="text.secondary">
              No CTOT information available
            </Typography>
          </Box>
        )}

        {ctot === "CANCELLED" && (
          <Alert
            severity="error"
            variant="outlined"
            sx={{
              mt: 2,
              border: 2,
              borderColor: "error.main",
            }}
          >
            <Typography variant="h6" fontWeight="bold" textAlign="center">
              CTOT Cancelled
            </Typography>
          </Alert>
        )}
      </DialogContent>
    </Dialog>
  );
};
